import { fromBech32, toBech32 } from '@cosmjs/encoding'

import { bridgelessChainRegistry } from '@/config'

const VALIDATOR_PREFIX = bridgelessChainRegistry[0]?.bech32_config
  ?.bech32PrefixValAddr as string

export const convertAddressPrefix = (
  address: string,
  targetPrefix: string = VALIDATOR_PREFIX,
) => {
  if (
    !address ||
    (address &&
      !address.startsWith(
        bridgelessChainRegistry?.[0]?.bech32_prefix as string,
      ))
  ) {
    throw new Error('Invalid address provided')
  }

  const { data } = fromBech32(address)

  return toBech32(targetPrefix, data)
}
